import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import api from 'services/api';
import toastApi from 'services/toast';

import { getErrorMessage } from 'utils/errorHandler';
import { useConfigurationStatus } from 'hooks/ApiStatus';

import Button from 'components/button';
import Modal from 'components/modal';
import PageTitleAndDescription from 'components/pageTitleAndDescription';

import importerMenuIcon from 'assets/svgs/importerMenuIcon.svg';
import publicationMenuIcon from 'assets/svgs/publicationMenuIcon.svg';

import {
  PageWrapper, ButtonWrapper, LastUpdate, Icon,
  ModificationsText, ModalContentContainer,
} from './styles';

const PublicationPage = () => {
  const { t } = useTranslation();

  const configurationStatus = useConfigurationStatus();

  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  const handleOnClickPublish = async () => {
    setOpenConfirmationModal(false);
    try {
      await api.publish();
    } catch (error) {
      toastApi.error(getErrorMessage(error));
    }
  };

  const renderHeader = () => (
    <PageTitleAndDescription
      title={t('pages.publicationPage.title')}
      description={t('pages.publicationPage.description')}
    />
  );

  const noneText = (isImport) => (isImport ? t('pages.publicationPage.noneImport') : t('pages.publicationPage.nonePublish'));
  const formatTime = (time) => moment(time).format('DD/MM/YYYY - HH[h]:mm');

  const renderLastUpdate = (isImport, time) => (
    <LastUpdate>
      <Icon src={isImport ? importerMenuIcon : publicationMenuIcon} />
      <p>{isImport ? t('pages.publicationPage.lastImport') : t('pages.publicationPage.lastPublish')}</p>
      <span>{time !== 0 ? formatTime(time) : noneText(isImport)}</span>
    </LastUpdate>
  );

  const modalContent = (
    <ModalContentContainer>
      {t('pages.publicationPage.confirmationModalMessage')}
    </ModalContentContainer>
  );

  return (
    <PageWrapper>
      <Modal
        labelPrimaryButton={t('pages.publicationPage.confirmationModalPrimaryButton')}
        labelSecondaryButton={t('pages.publicationPage.confirmationModalSecondaryButton')}
        content={modalContent}
        open={openConfirmationModal}
        onClickPrimaryButton={handleOnClickPublish}
        onClickSecondaryButton={() => setOpenConfirmationModal(false)}
      />
      <div>
        {renderHeader()}
        {renderLastUpdate(true, configurationStatus.lastImport)}
        {renderLastUpdate(false, configurationStatus.lastPublish)}
      </div>
      <ButtonWrapper>
        <ModificationsText hasModifications={configurationStatus.hasModifications}>
          {
            configurationStatus.hasModifications
              ? t('pages.publicationPage.hasModificationText')
              : t('pages.publicationPage.doesntHasModificationsText')
          }
        </ModificationsText>
        <Button
          loading={configurationStatus.isPublishing}
          loadingLabel={t('pages.publicationPage.ctaPublishLoading')}
          onClick={() => setOpenConfirmationModal(true)}
          disabled={!configurationStatus.hasModifications}
        >
          {t('pages.publicationPage.ctaPublish')}
        </Button>
      </ButtonWrapper>
    </PageWrapper>
  );
};

export default PublicationPage;
